<template>
  <div class="pb-8">
    <div class="mb-2 txt-headline-m-bold">
      <div class="flex items-center gap-2">
        <div>{{ label }}</div>
        <TooltipWrapper v-if="helpTooltip">
          <template #trigger>
            <a v-if="helpLink" :href="helpLink" data-testid="label-value-help-link" target="_blank"
              ><CircleHelpIcon class="lucide-icon-s text-icon-subtlest"
            /></a>
            <CircleHelpIcon v-else class="lucide-icon-s text-icon-subtlest" />
          </template>
          <template #content>
            <div v-html="helpTooltip"></div>
          </template>
        </TooltipWrapper>
      </div>
      <div class="mt-1 flex items-start txt-body-s-regular text-subtle">
        <MdiSvg v-if="showIcon" class="mt-1 mr-1 shrink-0" :path="mdiInformationOutline" :size="14" />
        <slot name="hint" />
      </div>
    </div>
    <div class="txt-body-s-regular"><slot /></div>
  </div>
</template>

<script setup lang="ts">
import { mdiInformationOutline } from '@mdi/js'
import { MdiSvg, TooltipWrapper } from '@ramp106/omrjs-core-ui'
import { CircleHelpIcon } from '@ramp106/omrjs-core-ui/icons'

defineProps<{
  label: string
  showIcon?: boolean
  helpLink?: string
  helpTooltip?: string
}>()
</script>
